import { loadStripe } from "@stripe/stripe-js";

const Hooks = {};

async function getStripe(publishableSecret) {
  return loadStripe(publishableSecret);
}

// TODO: Perhaps we can rename this file and module since it's used in many places
Hooks.InitStripeCheckout = {
  mounted() {
    const clientSecret = this.el.dataset.setupIntentClientSecret;
    const publishableSecret = this.el.dataset.stripePublishableKey;
    const mountedElement = this;

    getStripe(publishableSecret).then((stripe) => {
      const options = {
        clientSecret,
        currency: "usd",
      };

      // Set up Stripe.js and Elements to use in checkout form
      const elements = stripe.elements(options);

      // Create and mount the Payment Element
      const paymentElement = elements.create("payment");
      paymentElement.mount("#payment-element");

      // Now create payment method
      const form = document.getElementById("payment-form");
      const submitBtn = document.getElementById("submit");

      const handleError = (error) => {
        // Find container where we set error messages from Stripe.js
        const messageContainer = document.querySelector(
          "#stripe-error-message",
        );

        // Set the error message
        messageContainer.textContent = `Unable to add payment method. ${error.message}`;

        // Make the error visible
        messageContainer.parentElement.classList.remove("tw:hidden");

        // No longer disable the submit button
        submitBtn.disabled = false;
      };

      form.addEventListener("submit", async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        // Prevent multiple form submissions
        if (submitBtn.disabled) {
          return;
        }

        // Disable form submission while loading
        submitBtn.disabled = true;

        // Trigger form validation and wallet collection
        const { error: submitError } = await elements.submit();
        if (submitError) {
          handleError(submitError);
          return;
        }

        // TODO: Need to disable form and show loading spinner.
        const { error, setupIntent } = await stripe.confirmSetup({
          elements,
          redirect: "if_required",
          confirmParams: {
            expand: ["payment_method"],
          },
        });

        if (error) {
          // This point is only reached if there's an immediate error when
          // creating the PaymentMethod. Show the error to your customer (for example, payment
          // details incomplete)
          handleError(error);
          return;
        }

        // Create the SetupIntent
        // Send details to LiveView event handler to create the SetupIntent
        mountedElement.pushEvent("payment-method-success", setupIntent);
      });
    });
  },
};

Hooks.CardActions = {
  mounted() {
    const mountedElement = this;

    this.handleEvent("handle-card-action", (data) => {
      (async () => {
        const stripe = await loadStripe(data.publishable_key, {
          stripeAccount: data.stripe_account_id,
        });

        stripe.confirmCardPayment(data.client_secret).then((result) => {
          if (result.paymentIntent) {
            // Additional action was successfully completed by user, notify the server of this
            // so the payment record can be updated and user redirected to the receipt page.
            mountedElement.pushEvent("card-action-success", {
              payment_intent_id: result.paymentIntent.id,
              stripe_account_id: data.stripe_account_id,
            });
          } else if (result.error) {
            // Additional action failed, notify the server so that we can redirect the user to
            // the receipt page to show an error message.
            mountedElement.pushEvent("card-action-error", {
              error: result.error,
            });
          }
        });
      })();
    });
  },
};

export default Hooks;
